/****************************************************************************************************************
* ©2019 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { FormBase } from "../../util/form/form-base";
import { DynamicFormControlService } from "../../services/dynamic-form-control.service";
import { UntypedFormGroup } from "@angular/forms";
import { DropdownData } from './dynamic-form-field/dynamic-form-field.component';

@Component({
    selector: 'dynamic-form',
    templateUrl: './dynamic-form.component.html',
    styleUrls: ['./dynamic-form.component.scss'],
    standalone: false
})
export class DynamicFormComponent implements OnInit {

    rows: FormBase<any>[][] = [];
    @Input() schema: any = [];
    @Input() data: any = {};
    @Input() buttonLabel: string;
    form: UntypedFormGroup;
    showSpinner: boolean;
    @Input() readonly: boolean = false;

    @Output('onSubmit') sendData = new EventEmitter<any>();
    @Output('onDropdownSelectionChange') dropdownEvent: EventEmitter<DropdownData> = new EventEmitter();

    constructor(private qcs: DynamicFormControlService) { }

    ngOnInit() {
        this.showSpinner = true;
        if (!this.buttonLabel)
            this.buttonLabel = 'Submit';
        this.rows = this.qcs.schemaToQuestions(this.schema, this.data);
        this.form = this.qcs.toFormGroup(this.rows);
        this.showSpinner = false;
    }

    onSubmit() {
        let response = this.form.value;
        this.rows.forEach(row => {
            row.forEach(field => {
                if (!response.hasOwnProperty(field.key))
                    response[field.key] = this.data[field.key];
            });
        });
        this.sendData.emit(response);
    }

    onDropdownSelectionChange(dropdownData: DropdownData) {
        this.dropdownEvent.emit(dropdownData);
    }
}

